'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var lodash = require('lodash');
var React = require('react');
var styled = require('styled-components');
var polished = require('polished');
var TippyTooltip = require('@tippyjs/react');
require('./shift-away-subtle-0bed9a3c.js');
var maxSize = require('popper-max-size-modifier');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TippyTooltip__default = /*#__PURE__*/_interopDefaultLegacy(TippyTooltip);
var maxSize__default = /*#__PURE__*/_interopDefaultLegacy(maxSize);

var _templateObject, _templateObject2, _templateObject3;
var Popover$1 = styled__default['default'](TippyTooltip__default['default']).attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  font-weight: 400;\n  color: inherit;\n  border-radius: 0;\n  line-height: inherit;\n  max-height: inherit;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  .tippy-content {\n    padding: 0;\n    max-height: inherit;\n\n    > div {\n      max-height: inherit;\n    }\n  }\n\n  .tippy-arrow {\n    ", "\n  }\n\n  && > .tippy-arrow::before {\n    position: absolute;\n    border-color: transparent;\n    border-style: solid;\n  }\n\n  & > .tippy-arrow::after {\n    content: '';\n    position: absolute;\n    border-color: transparent;\n    border-style: solid;\n  }\n\n  &[data-placement^='top'] {\n    & > .tippy-arrow:before {\n      bottom: -16px;\n      left: -5px;\n      border-width: 15px 13px 0;\n      ", "\n    }\n\n    & > .tippy-arrow:after {\n      bottom: -15px;\n      left: -5px;\n      border-width: 15px 13px 0;\n      border-top-color: initial;\n      transform-origin: center top;\n    }\n  }\n\n  &[data-placement^='right'] {\n    & > .tippy-arrow:before {\n      bottom: -5px;\n      left: -16px;\n      border-width: 13px 15px 13px 0;\n      ", "\n    }\n\n    & > .tippy-arrow:after {\n      bottom: -5px;\n      left: -15px;\n      border-width: 13px 15px 13px 0;\n      border-right-color: initial;\n      transform-origin: center top;\n    }\n  }\n\n  &[data-placement^='bottom'] {\n    & > .tippy-arrow:before {\n      top: -16px;\n      left: -5px;\n      border-width: 0 13px 15px 13px;\n      ", "\n    }\n\n    & > .tippy-arrow:after {\n      top: -14.5px;\n      left: -5px;\n      border-width: 0 13px 15px 13px;\n      border-bottom-color: initial;\n      transform-origin: center top;\n    }\n  }\n\n  &[data-placement^='left'] {\n    & > .tippy-arrow::before {\n      bottom: -5px;\n      right: -16px;\n      border-width: 13px 0 13px 15px;\n      ", "\n    }\n\n    & > .tippy-arrow::after {\n      bottom: -5px;\n      right: -15px;\n      border-width: 13px 0 13px 15px;\n      border-left-color: initial;\n      transform-origin: center top;\n    }\n  }\n"])), function (props) {
  return props.theme.primaryFontFamily;
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('white'));
}, function (props) {
  return props.theme.themeProp('box-shadow', "0px 1px 6px -3px ".concat(polished.rgba(props.theme.getColor('black'), 0.7)), "0 1px 6px -4px ".concat(props.theme.getColor('black')));
}, function (props) {
  return props.theme.themeProp('border', "1px solid ".concat(props.theme.getColor('gray-800')), "1px solid ".concat(props.theme.getColor('gray-300')));
}, function (props) {
  return props.contextMenu && styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n      border-radius: 4px;\n\n      ", "\n\n      ", "\n    "])), function (props) {
    return props.theme.themeProp('border', 'none', 'none');
  }, function (props) {
    return props.theme.themeProp('box-shadow', "none", "0 1px 6px ".concat(polished.rgba(props.theme.getColor('gray-900'), 0.3)));
  });
}, function (props) {
  return props.contextMenuSublevel && styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n      &[data-placement^='right-start'],\n      &[data-placement^='left-start'] {\n        margin-top: -4px;\n      }\n\n      &[data-placement^='left'] {\n        margin-right: -6px;\n      }\n\n      &[data-placement^='right'] {\n        margin-left: -6px;\n      }\n    "])));
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-700'), props.theme.getColor('white'), 1);
}, function (props) {
  return props.theme.themeProp('border-top-color', props.theme.getColor('gray-800'), props.theme.getColor('gray-300'), 1);
}, function (props) {
  return props.theme.themeProp('border-right-color', props.theme.getColor('gray-800'), props.theme.getColor('gray-300'), 1);
}, function (props) {
  return props.theme.themeProp('border-bottom-color', props.theme.getColor('gray-800'), props.theme.getColor('gray-300'), 1);
}, function (props) {
  return props.theme.themeProp('border-left-color', props.theme.getColor('gray-800'), props.theme.getColor('gray-300'), 1);
});

var Popover = React__default['default'].forwardRef(function Popover(_ref, ref) {
  var content = _ref.content,
      interactive = _ref.interactive,
      placement = _ref.placement,
      duration = _ref.duration,
      trigger = _ref.trigger,
      offset = _ref.offset,
      arrow = _ref.arrow,
      visible = _ref.visible,
      contextMenu = _ref.contextMenu,
      contextMenuSublevel = _ref.contextMenuSublevel,
      children = _ref.children,
      modifiers = _ref.modifiers,
      props = defaultTheme._objectWithoutProperties(_ref, ["content", "interactive", "placement", "duration", "trigger", "offset", "arrow", "visible", "contextMenu", "contextMenuSublevel", "children", "modifiers"]);

  var errorOffset = React.useMemo(function () {
    return arrow ? 15 : 0;
  }, [arrow]);
  var isControlled = React.useMemo(function () {
    return lodash.isBoolean(visible);
  }, [visible]);

  var handleContextMenuItemClick = function handleContextMenuItemClick() {
    document.querySelectorAll('.context-menu-item:not(.opens-sublevel)').forEach(function (item) {
      return item.addEventListener('click', function () {
        document.querySelectorAll('[data-tippy-root]').forEach(function (node) {
          if (node._tippy) {
            node._tippy.hide();
          }
        });
      });
    });
  };

  return React__default['default'].createElement("div", null, React__default['default'].createElement(Popover$1, defaultTheme._extends({
    ref: ref,
    content: content,
    interactive: interactive,
    placement: contextMenuSublevel ? 'right-start' : placement,
    duration: duration,
    animation: 'shift-away-subtle',
    trigger: isControlled ? undefined : contextMenuSublevel ? 'mouseenter click focus' : trigger,
    offset: [offset[0], offset[1] + errorOffset],
    arrow: contextMenu ? false : arrow,
    visible: visible,
    popperOptions: {
      modifiers: [defaultTheme._objectSpread2(defaultTheme._objectSpread2({}, maxSize__default['default']), {}, {
        options: {
          boundary: 'viewport',
          rootBoundary: 'viewport',
          padding: 10
        }
      }), {
        name: 'applyMaxSize',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['maxSize'],
        fn: function fn(_ref2) {
          var state = _ref2.state;
          var height = state.modifiersData.maxSize.height;
          state.styles.popper = defaultTheme._objectSpread2(defaultTheme._objectSpread2({}, state.styles.popper), {}, {
            maxHeight: "".concat(height, "px")
          });
        }
      }].concat(defaultTheme._toConsumableArray(modifiers))
    },
    onShown: contextMenu ? handleContextMenuItemClick : undefined
  }, props), children));
});
Popover.propTypes = process.env.NODE_ENV !== "production" ? {
  content: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.string, defaultTheme.PropTypes.element]).isRequired,
  interactive: defaultTheme.PropTypes.bool,
  placement: defaultTheme.PropTypes.oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end']),
  duration: defaultTheme.PropTypes.number,
  trigger: defaultTheme.PropTypes.string,
  offset: defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.number),
  arrow: defaultTheme.PropTypes.bool,
  visible: defaultTheme.PropTypes.bool,
  modifiers: defaultTheme.PropTypes.array,
  contextMenu: defaultTheme.PropTypes.bool,
  contextMenuSublevel: defaultTheme.PropTypes.bool,
  children: defaultTheme.PropTypes.node.isRequired
} : {};
Popover.defaultProps = {
  content: 'Tooltip',
  interactive: true,
  placement: 'bottom-end',
  duration: 350,
  offset: [0, 8],
  maxWidth: 'none',
  trigger: 'click focus',
  arrow: true,
  visible: undefined,
  contextMenu: false,
  contextMenuSublevel: false,
  modifiers: []
};

exports.Popover = Popover;
